import { ShippingBacklogCancellationEffect } from './shipping-backlog-cancellation.effect';
import { ShippingBacklogOverviewEffect } from './shipping-backlog-overview.effect';

export const effects: any[] = [
  ShippingBacklogOverviewEffect,
  ShippingBacklogCancellationEffect,
];
